import React from 'react';
import HeadDoctorAppointmentsManager from '../appointments/HeadDoctorAppointmentsManager';

export default function HeadDoctorAppointmentsPage() {
  return <HeadDoctorAppointmentsManager />;
}
